import PropTypes from 'prop-types'
import React from 'react'

import {
    ARENA_EXCLUDED,
    ARENA_TOOLTIP_BATTLE_MAP,
    ARENA_TOOLTIP_DIRECTION,
    ARENA_TOOLTIP_TITLE,
} from './constants.jsx'

import { NAME_BY_DIRECTION } from 'helpers/i18n.jsx'

import { Tooltip, TooltipFooter } from 'react-wot-bootstrap'

import styles from './ArenaTooltip.scss'

const ArenaTooltip = (props) => {

    let title = null
    if (props.direction) {
        title = <h3 className={styles.title}>{ARENA_TOOLTIP_TITLE[props.point]}</h3>
    } else if (props.withTitle) {
        title = <h3 className={styles.title}>{props.arena.name}</h3>
    }

    let description = null
    if (props.direction) {
        description = (
            <p className={styles.details}>
                <span className={styles.caption}>{ARENA_TOOLTIP_DIRECTION(NAME_BY_DIRECTION[props.direction])}</span>
                <br/>
                <span className={styles.caption}>{ARENA_TOOLTIP_BATTLE_MAP(props.arena.name)}</span>
            </p>
        )
    } else if (props.children) {
        description = (
            <div className={styles.content}>
                {props.children}
            </div>
        )
    }

    let content
    if (props.arena.available_in_game) {
        const arenaImage = { backgroundImage: `url('${props.arena.image_url}')` }

        let emblems
        if (props.emblems && props.arena.bases) {
            if (props.emblems.length !== props.arena.bases.length || !props.arena.bases) {
                // eslint-disable-next-line no-console
                console.error(
                    '<ArenaTooltip> validation error: emblems number does not match bases coordinates,' +
                    'emblems will not be rendered'
                )
            } else {
                emblems = props.emblems.map((emblem, index) => {
                    const emblemPosition = props.arena.bases[index]
                    if (!emblemPosition) return

                    const emblemStyle = {
                        left: emblemPosition[0] + '%',
                        top: emblemPosition[1] + '%',
                    }

                    return (
                        <div key={index} className={styles.minimapEmblem} style={emblemStyle}>
                            {emblem}
                        </div>
                    )
                })
            }
        }
        content = (
            <div className={styles.minimap} style={arenaImage}>
                {emblems}
            </div>
        )
    } else {
        if (title) {
            content = (
                <TooltipFooter>
                    {ARENA_EXCLUDED}
                </TooltipFooter>
            )
        } else {
            content = ARENA_EXCLUDED
        }
    }

    return (
        <Tooltip id={props.tooltipId}>
            {title}
            {description}
            {content}
        </Tooltip>
    )
}

ArenaTooltip.propTypes = {
    tooltipId: PropTypes.string.isRequired,
    point: PropTypes.number,
    direction: PropTypes.string,
    withTitle: PropTypes.bool,
    arena: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        available_in_game: PropTypes.bool,
        bases: PropTypes.arrayOf(
            PropTypes.arrayOf(
                PropTypes.number,
            )
        ),
        image_url: PropTypes.string,
    }).isRequired,

    emblems: PropTypes.arrayOf(
        PropTypes.element
    ),
}

export default ArenaTooltip



// WEBPACK FOOTER //
// ./components/ArenaTooltip/ArenaTooltip.jsx